var __webpack_exports__ = {};
/*!*************************************!*\
  !*** ./src/js/collection-facets.js ***!
  \*************************************/
document.addEventListener('DOMContentLoaded', function () {
  var header = document.getElementById('header');
  var productGrid = document.getElementById('ProductGridContainer');
  var headerHeight = header.offsetHeight;
  var topPosition = productGrid.offsetTop - headerHeight;
  document.addEventListener('facetChange', function (event) {
    if (productGrid && header) {
      productGrid.style.opacity = '0';
      // Fade-in effect
      setTimeout(function () {
        productGrid.style.transition = 'opacity 0.3s ease-out';
        productGrid.style.opacity = '1';
      }, 900);
      if (window.scrollY > topPosition + 100) {
        window.scrollTo({
          top: topPosition,
          behavior: 'smooth'
        });
      }
    }
  });
});
